import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { RateService } from 'common/data';

class RateServiceStore extends BaseStore {
	constructor(rootStore) {
		super(new RateService(rootStore.app.baasic.apiClient));
	}

	@action
	getAmazonShippingServices = async requestBody => {
		const response = await this.service.getAmazonShippingServices(requestBody);
		this.response = response.data;
	};

	@action
	findCarrierServiceWithRates = async filter => {
		const response = await this.service.findCarrierServiceWithRates(filter);
		if (filter) {
			response.data.searchQuery = filter.rateSearchRest.search;
		}
		this.response = response.data;
	};

	@action
	fetchRates = async requestBody => {
		const response = await this.service.fetchRates(requestBody);
		this.response = response.data;
		return response.data;
	};

	@action
	getRates = async rateParams => {
		const response = await this.service.getRates(rateParams);
		this.response = response.data;
	};
}

export default RateServiceStore;



// WEBPACK FOOTER //
// ./src/modules/rate/stores/RateServiceStore.js